import { render, staticRenderFns } from "./CantineNewDashboard.vue?vue&type=template&id=08f7dca8&scoped=true&"
import script from "./CantineNewDashboard.vue?vue&type=script&lang=js&"
export * from "./CantineNewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CantineNewDashboard.vue?vue&type=style&index=0&id=08f7dca8&scoped=true&lang=css&"
import style1 from "./CantineNewDashboard.vue?vue&type=style&index=1&id=08f7dca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7dca8",
  null
  
)

export default component.exports